<template>
  <div class="py-4 container-fluid">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <div>
        <h4 class="mb-0">System Users</h4>
        <p class="text-muted">Manage system users, roles, and permissions</p>
      </div>

      <div>
        <button class="btn btn-success me-2" @click="showAddUser(null)">
          <i class="fas fa-user-plus me-1"></i> Add User
        </button>
        <button class="btn btn-primary" @click="$router.push('/system_roles')">
          <i class="fas fa-user-cog me-1"></i> Roles & Permissions
        </button>
        <!-- <button @click="deleteUser2">check</button> -->
      </div>
    </div>

    <div class="card">
      <div class="card-body table-responsive p-0">
        <table class="table table-hover align-items-center mb-0">
          <thead class="thead-light">
            <tr>
              <th>User ID</th>
              <th>Name</th>
              <th>Email Address</th>

              <th>Assigned Role</th>
              <th>Created Date</th>
              <th class="text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in users" :key="user.id">
              <td>#{{ user.id }}</td>
              <td>{{ user.name }}</td>
              <td>{{ user.email }}</td>

              <td>
                <span class="badge bg-primary">{{ user.role }}</span>
              </td>
              <td>{{ formatDate(user.created_at) }}</td>
              <td class="text-center">
                <button
                  class="btn btn-sm btn-info mr-1"
                  @click="showAddUser(user.id)"
                >
                  <i class="fas fa-edit me-1"></i> Edit
                </button>
                <button
                  class="btn btn-sm btn-danger mr-1"
                  @click="deleteUser(user)"
                >
                  <i class="fas fa-trash me-1"></i> Delete
                </button>
                <!-- <button
                  class="btn btn-sm btn-secondary"
                  @click="managePermissions(user)"
                >
                  <i class="fas fa-user-lock me-1"></i> Permissions
                </button> -->
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination (optional placeholder) -->
      <!-- <div class="card-footer d-flex justify-content-end">
        <nav>
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item">
              <a class="page-link" href="#">Previous</a>
            </li>
            <li class="page-item"><a class="page-link" href="#">1</a></li>
            <li class="page-item"><a class="page-link" href="#">2</a></li>
            <li class="page-item"><a class="page-link" href="#">Next</a></li>
          </ul>
        </nav>
      </div> -->
    </div>
  </div>

  <add_system_user_modal
    @close-add-sys-user-mod="closeAddUser"
    :user_id="current_user_id"
    v-if="show_add_sys_user_modal"
  />
</template>

<script>
import { generalApiRequest } from "../../api/apiIndex";
import showNotification from "../../notification/notify";
import add_system_user_modal from "./add_system_user_modal.vue";
export default {
  name: "SystemUsersDashboard",
  data() {
    return {
      show_add_sys_user_modal: false,
      current_user_id: null,
      users: [],
    };
  },
  components: {
    add_system_user_modal,
  },
  methods: {
    async getUsers() {
      const url = "getSystemUsersByCompany";
      const body = {};
      const rs = await generalApiRequest(url, "GET", body, 1);
      this.users = rs.data;
    },
    saveUser() {
      // your save logic...
      showNotification("User saved successfully!", "success");
    },
    deleteUser2() {
      showNotification("User deleted!", "error");
    },
    showAddUser(id) {
      console.log(id);

      this.current_user_id = id;
      this.show_add_sys_user_modal = true;
    },
    closeAddUser() {
      this.current_user_id = null;
      this.show_add_sys_user_modal = false;
      this.getUsers();
    },
    formatDate(date) {
      const options = { year: "numeric", month: "short", day: "numeric" };
      return new Date(date).toLocaleDateString(undefined, options);
    },
    editUser(user) {
      this.$router.push(`/system-users/edit/${user.id}`);
    },
    async deleteUser(user) {
      if (confirm(`Are you sure you want to delete ${user.name}?`)) {
        const url = "deleteSystemUser";
        const body = { id: user.id };
        const rs = await generalApiRequest(url, "POST", body, 1);
        this.getUsers();
        alert(rs.message);
      }
    },
    managePermissions(user) {
      this.$router.push(`/system-users/${user.id}/permissions`);
    },
  },

  mounted() {
    this.getUsers();
  },
};
</script>

<style scoped>
.table th,
.table td {
  vertical-align: middle;
}
</style>
